import styled from 'styled-components';

import { buttonStyles } from './styled';

const PdfCircleButton = styled.button.attrs(() => ({ type: 'button' }))`
  ${buttonStyles};
`;

export default PdfCircleButton;
